import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./lib/auth";
import { ActiveFlatProvider } from "./lib/active-flat";
import { ToastProvider } from "./lib/toast";
import { CurrencyProvider } from "./lib/currency";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("root element not found");

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ActiveFlatProvider>
          <CurrencyProvider>
            <ToastProvider>
              <App />
            </ToastProvider>
          </CurrencyProvider>
        </ActiveFlatProvider>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
